// extracted by mini-css-extract-plugin
export var button = "_nv-2";
export var card = "_nv-0";
export var closeButtonContainer = "_nv-3";
export var iconContainer = "_nv-1";